import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";

export default function Services() {
  return (
    <div className="services" id="services">
      <h1 className="section_header">WHAT I DO</h1>
      <AnimationOnScroll animateIn="animate__fadeIn" offset="150">
        {/* <p className="services__detail">
          A custom web application that meets your needs. <br />I use ReactJS as
          frontend technology, nodejs for backend and cloud base databases for
          data storage such as MongoAtlas.
          <br />
          I will put all my knowledge and my experience to produce the result
          that fulfills your satisfaction.
          <br />
          In nutshell i will offer you the chance to transform your ideas into
          reality.
          <br />
          So don't hesitate to <a href="#contact">contact me</a> if you need
          help.
        </p> */}
        <p className="services__detail">
        I specialize in crafting seamless and dynamic web experiences, leveraging a robust background in both <nobr>front-end</nobr> and <nobr>back-end</nobr> technologies.
          <br />
          My holistic approach to web development is marked by proficiency in languages like HTML, CSS, and JavaScript, complemented by expertise in frameworks such as React on the front end and Node.js on the server side.
          <br />
          With these skills, I am adept at building responsive and scalable web applications.
          <br />
          f you're in need of assistance, don't hesitate to <a href="#contact">contact me</a> I'm ready to bring innovative solutions to your projects.

        </p>
      </AnimationOnScroll>
    </div>
  );
}

